import {
  CLEAR_SELECTED_SEARCH_MEMBERS,
  SEARCH_USERS_FAILURE,
  SEARCH_USERS_REQUEST,
  SEARCH_USERS_SUCCESS,
  SET_SELECTED_SEARCH_MEMBERS,
  REMOVE_SELECTED_SEARCH_MEMBER,
} from "../../constants"
import { backendAPI } from "../../api"

export const setSelectedSearchMembers = (members) => ({
  type: SET_SELECTED_SEARCH_MEMBERS,
  payload: members,
})

export const clearSelectedSearchMembers = () => ({
  type: CLEAR_SELECTED_SEARCH_MEMBERS,
})

export const removeSelectedSearchMember = (memberId) => ({
  type: REMOVE_SELECTED_SEARCH_MEMBER,
  payload: memberId,
})

export const searchUsers = (query) => async (dispatch) => {
  dispatch({ type: SEARCH_USERS_REQUEST })
  try {
    const url = "/users/search"
    const res = await backendAPI.get(url, { params: { param: query } })
    // only include users that are not already part of a group
    dispatch({ type: SEARCH_USERS_SUCCESS, payload: res.data.filter((u)=> !u.group_id) })
  } catch (error) {
    console.error("Error searching users:", error.message)
    // Dispatch failure action with error message
    dispatch({ type: SEARCH_USERS_FAILURE, error: error.message })
  }
}
